import constants from 'utils/constants';
import utils from 'utils/utils';

var textSnapshot = null;

function bindSelectionFixToCommandExec(editor) {
    editor.on('beforeCommandExec', function (evt) {
        fixSelectionIfNeeded(evt.editor);
    }, null, null, 0);

    editor.on('afterCommandExec', function () {
        clearTextSnapshot();
    });

    editor.editable().on('cut', function () {
        clearTextSnapshot();
    });

    editor.editable().on('copy', function () {
        clearTextSnapshot();
    });

    editor.on('paste', function () {
        clearTextSnapshot();
    }, null, null, 0);
}

function fixSelectionIfNeeded(editor) {
    var range = editor.getSelection().getRanges()[0];
    if (!range) {
        return;
    }

    if (utils.isSpellCheckCorrectionOccurred(editor.editable().getText(), getTextSnapshot())) {
        var nativeSelection = editor.document.$.getSelection();

        range.setStart(new CKEDITOR.dom.node(nativeSelection.anchorNode), nativeSelection.anchorOffset);
        range.setEnd(new CKEDITOR.dom.node(nativeSelection.focusNode), nativeSelection.focusOffset);
    }
}

function bindContextMenuEvents(editor) {
    function handleContextMenu() {
        setTextSnapshot(editor.editable().getText());
    }

    editor.document.$.oncontextmenu = handleContextMenu;

    /**
     * Since IE doesn't fire oncontextmenu event when spell check is enabled, need to catch these events
     */
    editor.document.$.onmousedown = function (e) {
        if (e.button === constants.MOUSE_RIGHT_CLICK_BUTTON) {
            handleContextMenu();
        }
    };

    editor.document.$.onkeydown = function (e) {
        clearTextSnapshot();

        if (e.key === constants.WINDOWS_APPS_KEY) {
            handleContextMenu();
        }
    };
}

function bindToSpellCheckEvents(editor) {
    bindContextMenuEvents(editor);
    bindSelectionFixToCommandExec(editor);
}

function clearTextSnapshot() {
    textSnapshot = null;
}

function getTextSnapshot() {
    return textSnapshot;
}

function setTextSnapshot(text) {
    textSnapshot = text;
}

export default {
    bindToSpellCheckEvents: bindToSpellCheckEvents
};
